import { render, staticRenderFns } from "./v-bank-field.vue?vue&type=template&id=72b93ad4&scoped=true&"
import script from "./v-bank-field.vue?vue&type=script&lang=js&"
export * from "./v-bank-field.vue?vue&type=script&lang=js&"
import style0 from "./v-bank-field.vue?vue&type=style&index=0&id=72b93ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b93ad4",
  null
  
)

export default component.exports